import _ from "lodash";

export const validateObject = {
  /**
   *
   * @param obj Objects need to get property
   */
  getKeys(obj: any) {
    //* is the result of all the properties we need to retrieve
    const subObj = { arr: [] as any[] } as any;

    /**
     *
     * @param obj The object needs checking to be added to the array
     * @param subObj array of properties taken
     */
    (function iterate(obj: any, subObj: any) {
      for (const property in obj) {
        if (obj.hasOwnProperty(property)) {
          subObj.arr = [...subObj.arr, property];
          if (_.isObject(obj[property]) && !_.isArray(obj[property])) {
            iterate(obj[property], subObj);
          }
        }
      }
    })(obj, subObj);
    return [...new Set(subObj.arr)] as string[];
  },
  /**
   *
   * @param obj Objects need compare
   * @param arrProps Array need to compare
   */
  has(obj: any, arrProps: string[]) {
    //* Returns true if the properties of the object including the ArrayProps are to be compare
    return _.isEqual(_.intersection(arrProps, this.getKeys(obj)), arrProps);
  },
  get (object, path) {
    return _.get(object, path);
  }
};
